var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.timeDifference)?_c('span',{staticClass:"downtime"},[_vm._v("-"+_vm._s(_vm.days)+"d "+_vm._s(_vm.hours)+"h "+_vm._s(_vm.minutes)+"m")]):_c('span',{staticClass:"snippet",attrs:{"data-title":"dot-pulse"}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stage"},[_c('div',{staticClass:"dot-pulse"})])
}]

export { render, staticRenderFns }